import React from "react";
import {Colors} from "../assets/colors/Colors";
import {ConstantEventEmitter} from "../data/ConstantEventEmitter";
import {changeActionsTable} from "../util/functions";
import {useSelector} from "react-redux";
import {useLocation} from "react-router-dom";


const AccionesTable = ({accionesBasicas = true, deleteAccion = true, editAction = true, viewAction = true, params, otrasAcciones = null}) => {

  let location = useLocation();
  const permissions = useSelector(state => state.permissions);

  return(
       <div className="d-flex justify-content-center align-items-center h-100">
           { accionesBasicas &&
           <>
           {  editAction &&
             <React.Fragment>
               {
                 permissions[location.pathname]?.U === 'S'
                 ? <i onClick={() => changeActionsTable({type: ConstantEventEmitter.keyActionsTableEdit, params, id: params.node.data.id})} style={{color: Colors.GREEN_SWITCH_ACTIVE, cursor: "pointer"}} className="far fa-edit fa-lg mx-1"/>
                 : <i style={{color: Colors.RED_SWITCH_INACTIVE, cursor: "pointer"}} className="fas fa-user-lock fa-lg mx-1"/>
               }
             </React.Fragment>
           }

           {
            viewAction &&
             <React.Fragment>
               {
                 permissions[location.pathname]?.R === 'S'
                   ? <i onClick={() => changeActionsTable({type: ConstantEventEmitter.keyActionsTableView, params, id: params.node.data.id})} style={{color: Colors.COLOR_AMOVIL_BLUE_DARK, cursor: "pointer"}} className="far fa-eye fa-lg mx-1"/>
                   : <i style={{color: Colors.RED_SWITCH_INACTIVE, cursor: "pointer"}} className="fas fa-user-lock fa-lg mx-1"/>
               }
             </React.Fragment>
           }

           </>
           }
           { deleteAccion &&

           <React.Fragment>
             {
               permissions[location.pathname]?.D === 'S'
                 ? <i onClick={() => changeActionsTable({type: ConstantEventEmitter.keyActionsTableDelete, params, id: params.node.data.id})} style={{color: Colors.RED_SWITCH_INACTIVE, cursor: "pointer"}} className="far fa-trash-alt fa-lg mx-1"/>
                 : <i style={{color: Colors.RED_SWITCH_INACTIVE, cursor: "pointer"}} className="fas fa-user-lock fa-lg mx-1"/>
             }
           </React.Fragment>

           }
           { otrasAcciones &&
           <React.Fragment>
             {
               permissions[location.pathname]?.U === 'S'
                 ? otrasAcciones
                 : <i style={{color: Colors.RED_SWITCH_INACTIVE, cursor: "pointer"}} className="fas fa-user-lock fa-lg mx-1"/>
             }
           </React.Fragment>
           }
       </div>
   )

}

export default AccionesTable;
